import axiosBase from 'axios';

import config from 'config';
import { configureAxios, configureAxiosWithToken } from 'utils/axios';

export const axiosWithToken = axiosBase.create({
  baseURL: config.apiBaseUrl
});

configureAxiosWithToken(axiosWithToken);

export const axios = axiosBase.create({
  baseURL: config.apiBaseUrl
});

configureAxios(axios);
